<template>
  <div v-if="fedExChoices && fedExChoices.length > 0">
    <div class="fed-ex mt-5 flex flex-col leading-6">
      <p class="text-md font-bold">{{ $t("shared.checkout.fed_ex") }}</p>
      <div class="mt-4 grid gap-3">
        <template v-for="(choice, index) in fedExChoices" :key="index">
          <div class="delivery-option">
            <VcRadioButton
              :id="choice.rateModeId"
              v-model="selectedShippingMethod"
              :value="choice.rateModeId"
              name="shippingSelection"
              class="rounded-md font-semibold"
              :label="getShippingOptionFriendlyName(choice.modeText)"
            >
            </VcRadioButton>
            <span
              class="order-3 pl-7 font-medium text-[--color-neutral-a2] md:order-none md:pl-0 md:text-[--color-neutral-a1]"
            >
              {{ getTransitTimeDisplay(choice, t) }}
            </span>
            <span
              v-show="!shippingAccountNumber && !shippingAccountNumberRecalculateTotals"
              class="text-right font-semibold md:text-left"
            >
              <VcPriceDisplay :formatted-value="formatPrice(choice.totalFreightAmount, currentCurrency)">
              </VcPriceDisplay>
            </span>
          </div>

          <div
            v-if="
              fedExExpediteIt &&
              choice.modeText.includes('Economy') &&
              !shippingAccountNumber &&
              !shippingAccountNumberRecalculateTotals
            "
            class="delivery-option items-start text-sm md:text-base"
          >
            <p class="flex items-center gap-[6px] pl-7 font-semibold leading-6 text-[--color-primary-a1] md:w-[160px]">
              <VcIcon name="expedite" class="" :size="16"></VcIcon>
              {{ $t("shared.checkout.expedite_it") }}
            </p>
            <p class="flex flex-col font-semibold leading-6 text-[--color-primary-a1]">
              {{ $t("shared.checkout.expedite_days", [choice.minimumTransitTimeInDays]) }}
              <span class="text-sm font-medium leading-6 text-[--color-neutral-a2]">
                {{ $t("shared.checkout.place_order") }}
              </span>
            </p>
          </div>
        </template>
      </div>
    </div>
    <span class="mt-5 flex h-px w-[50px] bg-[--color-neutral-a4]"></span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useCurrency } from "@/core/composables";
import { getShippingOptionFriendlyName, getTransitTimeDisplay } from "@/core/utilities";
import { formatPrice } from "@/shared/cart/utils/formatPrice";
import type { ShippingChoiceType } from "../../types";

const emit = defineEmits<{
  "update:selectedShippingMethod": [value: string];
}>();

const props = defineProps<IProps>();

const { t } = useI18n();

interface IProps {
  fedExChoices: ShippingChoiceType[];
  selectedShippingMethod: string;
  shippingAccountNumber: string;
  shippingAccountNumberRecalculateTotals: string;
  fedExExpediteIt: boolean;
}

const { currentCurrency } = useCurrency();

const selectedShippingMethod = computed({
  get: () => props.selectedShippingMethod,
  set: (value: string) => emit("update:selectedShippingMethod", value),
});
</script>

<style lang="scss" scoped>
.delivery-option {
  @apply grid gap-1 md:gap-0;

  grid-template-columns: subgrid;
  grid-column: span 4;
  @media (max-width: theme("screens.sm-max")) {
    grid-column: span 2;
  }
}
</style>
